export default __webpack_public_path__ + "static/media/zrak-stiny.aaa3dbda.svg";